import {
  IconButton as MuiIconButton,
  DialogTitle as MuiDialogTitle,
  styled,
} from "@mui/material";

export const DialogTitle = styled(MuiDialogTitle)<{ $empty: boolean }>(
  ({ $empty }) => ({
    position: "relative",
    padding: $empty ? 0 : '1rem',
    paddingRight: $empty ? 0 : "3.5rem",
  })
)

export const IconButton = styled(MuiIconButton)(({ theme }) => ({
  position: "absolute",
  right: "0.5rem",
  top: "0.5rem",
  color: theme.palette.grey[500],
}));
